import { render, staticRenderFns } from "./ArticlesPage.html?vue&type=template&id=7f743458&scoped=true&"
import script from "./ArticlesPage.ts?vue&type=script&lang=ts&"
export * from "./ArticlesPage.ts?vue&type=script&lang=ts&"
import style0 from "./ArticlesPage.scss?vue&type=style&index=0&id=7f743458&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f743458",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
